import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import FlexContainer from 'core-system/FlexContainer'
import palette from 'core-system/Themes/palette'
import { ReactComponent as SuccessIcon } from 'features/Programs/Success/Components/success-icon.svg'

const Section = styled.div`
  margin-top: 1rem;
`

const SectionTitle = styled(Text)`
  font-weight: 600;
  margin-bottom: 0.75rem;
`

const GuidelineText = styled(Text)`
  color: ${palette.text.secondary};
  margin-bottom: 1.5rem;
  line-height: 1.5;
`

const ChecklistItem = styled(FlexContainer)`
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`

const PurpleSuccessIcon = styled(SuccessIcon)`
  width: 1.25rem;
  height: 1.25rem;
  color: ${palette.secondary.purple600};
`

const requiredInfo = [
  'Date of purchase',
  'Total amount paid',
  'Vendor/merchant name',
  'Description of service',
]

const GuidelinesCard = React.memo(() => {
  return (
    <>
      <SectionTitle variant='body1'>What receipts can I upload?</SectionTitle>
      <GuidelineText variant='body2'>
        You can upload receipts for qualifying commuting expenses included in
        the applicable program. Receipts must clearly show the date, total
        amount, and vendor name.
      </GuidelineText>
      <SectionTitle variant='body1'>Required Information</SectionTitle>
      {requiredInfo.map((item) => (
        <ChecklistItem key={item}>
          <PurpleSuccessIcon />
          <Text variant='body2' textColor={palette.text.secondary}>
            {item}
          </Text>
        </ChecklistItem>
      ))}
      <Section>
        <SectionTitle variant='body1'>Transit reimbursements</SectionTitle>
        <GuidelineText variant='body2'>
          Transit reimbursements do not qualify for pre-tax commuter benefits and
          cannot be applied to pre-tax allocations. They are reimbursed from the
          next eligible budget and treated as post-tax.
        </GuidelineText>
      </Section>
    </>
  )
})

if (process.env.NODE_ENV !== 'production') {
  GuidelinesCard.displayName = 'GuidelinesCard'
}

export default GuidelinesCard
